function initReviewsSearch(root) {
  const searchInput = root.querySelector('[data-reviews-search]');
  const productSelect = root.querySelector('[data-reviews-product-filter]');
  const items = Array.from(root.querySelectorAll('[data-review-item]'));
  const countEl = root.querySelector('[data-reviews-count]');
  const emptyEl = root.querySelector('[data-reviews-empty]');

  if (!items.length) return;

  let activeProduct = 'all';

  function applyFilters() {
    const query = (searchInput && searchInput.value ? searchInput.value : '').trim().toLowerCase();
    let visibleCount = 0;

    items.forEach((item) => {
      const matchesSearch = query === '' || (item.dataset.search || '').includes(query);
      const matchesProduct = activeProduct === 'all' || item.dataset.product === activeProduct;
      const visible = matchesSearch && matchesProduct;
      item.classList.toggle('reviews-searchable__item--hidden', !visible);
      if (visible) visibleCount += 1;
    });

    if (countEl) {
      countEl.textContent = `Showing ${visibleCount} of ${items.length} review${items.length === 1 ? '' : 's'}`;
    }
    if (emptyEl) {
      emptyEl.hidden = visibleCount !== 0;
    }
  }

  if (searchInput) {
    searchInput.addEventListener('input', applyFilters);
  }

  if (productSelect) {
    productSelect.addEventListener('change', () => {
      activeProduct = productSelect.value;
      applyFilters();
    });
  }

  applyFilters();
}

document.querySelectorAll('[data-reviews-searchable]').forEach(initReviewsSearch);
